// DEAD CODE (TAN-9020): confirmed unreachable — Upload.tsx only renders it when
// progress is 1–99, and its single consumer (CropImage) never passes progress,
// so the branch never fires. Repointed to CircularProgress v2 only to drop the
// v1 atom cleanly; the component itself is never mounted at runtime.
import React from 'react';
import { CircularProgress, Icon } from 'ui';
import { useTranslate } from 'core/hooks/useTranslate';

type UploadedProgressProps = {
  progress?: number;
  subTitle?: string;
  title?: string;
};

function UploadedProgress({ progress = 0, subTitle = '', title = '' }: UploadedProgressProps): JSX.Element {
  const { t } = useTranslate();

  return (
    <div className="uploaded-progress">
      <span className="title">{title}</span>
      <div className="uploaded-progress-box">
        <Icon name="cloud-saved" />
        <CircularProgress hasCenterContent={false} label={t('common:going_up')} progress={progress} size="lg" />

        <div>
          <span className="going-up">{t('common:going_up')}</span>
        </div>
      </div>
      <span className="sub-title">{subTitle}</span>
    </div>
  );
}

export default UploadedProgress;
